import { useRef, useState } from "react";
import { useIntl } from "react-intl";
import SweetAlert2 from "react-sweetalert2";
import { CopyToClipboard } from "../../utils/CommonHelper";
import { Modal } from "./Modal";

export const ShareAccountDialog = ({ modalId, data }) => {
  const intl = useIntl();
  const dismissBtnRef = useRef();
  const [swalProps, setSwalProps] = useState({});

  const buildCopyText = () => {
    if (!data) return "";
    const parts = [];
    if (data.weburl) {
      parts.push(
        `${intl.formatMessage({ id: "webUrl" })}: ${data.weburl}`
      );
    }
    if (data.telegramactiveurl) {
      parts.push(
        `${intl.formatMessage({ id: "telegramActiveUrl" })}: ${data.telegramactiveurl}`
      );
    }
    if (data.username) {
      parts.push(
        `${intl.formatMessage({ id: "username" })}: ${data.username}`
      );
    }
    if (data.password) {
      parts.push(
        `${intl.formatMessage({ id: "password" })}: ${data.password}`
      );
    }
    return parts.join("\n");
  };

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => setSwalProps({})}
        {...swalProps}
      />
      <Modal
        modalId={modalId}
        title={intl.formatMessage({ id: "shareDetails" })}
        dismissBtnRef={dismissBtnRef}
      >
        <div className="p-3 custom-border-bottom">
          {data && (
            <div className="d-flex flex-column flex-md-row">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "max-content max-content auto",
                  columnGap: "0.5rem",
                }}
              >
                {data.weburl && (
                  <>
                    <div>{intl.formatMessage({ id: "webUrl" })}</div>
                    <div>:</div>
                    <div>{data.weburl}</div>
                  </>
                )}
                {data.telegramactiveurl && (
                  <>
                    <div>
                      {intl.formatMessage({ id: "telegramActiveUrl" })}
                    </div>
                    <div>:</div>
                    <div>{data.telegramactiveurl}</div>
                  </>
                )}
                {data.username && (
                  <>
                    <div>{intl.formatMessage({ id: "username" })}</div>
                    <div>:</div>
                    <div>{data.username}</div>
                  </>
                )}
                {data.password && (
                  <>
                    <div>{intl.formatMessage({ id: "password" })}</div>
                    <div>:</div>
                    <div>{data.password}</div>
                  </>
                )}
              </div>
              <div className="align-self-end align-self-md-center mt-3 mt-md-0 ms-md-5">
                <i
                  className="bi bi-copy fs-3"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    CopyToClipboard(buildCopyText(), setSwalProps, intl)
                  }
                ></i>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};
